// import anime from 'animejs';

// export const animations = {
//   fadeIn: {
//     opacity: [0, 1],
//     duration: 1000,
//     easing: 'easeInOutQuad',
//   },
//   slideUp: {
//     translateY: [100, 0],
//     opacity: [0, 1],
//     duration: 1000,
//     easing: 'easeOutQuad',
//   },
//   scaleUp: {
//     scale: [0.5, 1],
//     opacity: [0, 1],
//     duration: 1500,
//     easing: 'easeOutQuad',
//   },
// };

// const ANIMATION_DONE_CLASS = 'animation-done'; // Класс для отслеживания анимированных элементов

// // Функция для применения анимации
// const applyAnimation = (element) => {
//   console.log('Applying animation to:', element); // Логируем, когда применяется анимация
//   if (element.classList.contains('fade-in')) {
//     anime({
//       ...animations.fadeIn,
//       targets: element,
//     });
//   }
//   if (element.classList.contains('slide-up')) {
//     anime({
//       ...animations.slideUp,
//       targets: element,
//     });
//   }
//   if (element.classList.contains('scale-up')) {
//     anime({
//       ...animations.scaleUp,
//       targets: element,
//     });
//   }

//   element.classList.add(ANIMATION_DONE_CLASS); // Убедитесь, что элемент помечен как анимированный
// };

// // Настройка IntersectionObserver для отслеживания появления элементов в области видимости
// export const initAnimations = () => {
//   console.log('Initializing animations...'); // Логируем, когда инициализируем анимации

//   const observerOptions = {
//     root: null, // Отслеживание видимости относительно окна
//     rootMargin: '0px', // Без отступов
//     threshold: 0.3, // Срабатывает, когда 50% элемента видно
//   };

//   const observer = new IntersectionObserver((entries, observerInstance) => {
//     console.log('Observer callback fired'); // Логируем вызов обратного вызова
//     entries.forEach((entry) => {
//       console.log('Element isIntersecting:', entry.isIntersecting, entry.target);

//       // Проверка, что элемент пересек область видимости и не анимирован
//       if (entry.isIntersecting && !entry.target.classList.contains(ANIMATION_DONE_CLASS)) {
//         applyAnimation(entry.target); // Применяем анимацию
//         entry.target.classList.add(ANIMATION_DONE_CLASS); // Добавляем класс после анимации
//         observerInstance.unobserve(entry.target); // Прекращаем отслеживание этого элемента
//       }
//     });
//   }, observerOptions);

//   // Находим все элементы, которые должны быть анимированы
//   const elements = document.querySelectorAll('.fade-in, .slide-up, .scale-up');
//   console.log('Elements to animate:', elements); // Логируем, какие элементы будут анимированы

//   elements.forEach((element) => {
//     // Проверяем, если элемент еще не анимирован
//     if (!element.classList.contains(ANIMATION_DONE_CLASS)) {
//       observer.observe(element); // Начинаем отслеживание каждого элемента
//     }
//   });
// };
// export const initAnimationsLoaded = () => {
//   document.addEventListener('DOMContentLoaded', () => {
//     initAnimations();
//   });
// }

import anime from 'animejs';

const animations = {
  fadeIn: (els) => {
    anime({
      targets: els,
      opacity: [0, 1],
      translateY: [20, 0],
      easing: 'easeOutQuad',
      duration: 800,
      delay: anime.stagger(300),
    });
  },

  slideUp: (els) => {
    anime({
      targets: els,
      opacity: [0, 1],
      translateY: [50, 0],
      easing: 'easeOutQuad',
      duration: 1000,
      delay: anime.stagger(300),
    });
  },

  slideAppear: (el) => {
    anime({
      targets: el,
      opacity: [0, 1],
      scale: [0.8, 1],
      easing: 'easeOutQuad',
      duration: 1000,
    });
  },

  slideRightToLeft: (els) => {
    anime({
      targets: els,
      opacity: [0, 1],
      translateX: [100, 0],
      easing: 'easeOutQuad',
      duration: 1000,
      delay: anime.stagger(300),
    });
  }
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const parent = entry.target.closest('[data-animate-group]');
      if (parent) {
        const siblings = [...parent.children];
        const animationType = siblings[0].dataset.animate;
        if (animationType && animations[animationType]) {
          animations[animationType](siblings);
        }
      } else {
        const animationType = entry.target.dataset.animate;
        if (animationType && animations[animationType]) {
          animations[animationType]([entry.target]);
        }
      }
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.2 });

export const registerAnimations = () => {
  document.querySelectorAll('[data-animate]').forEach((el) => {
    el.style.opacity = '0'; // Скрываем элементы до момента анимации
    observer.observe(el);
  });

  document.querySelectorAll('.splide').forEach((slider) => {
    slider.style.opacity = '0'; // Скрываем слайдер до появления
    observer.observe(slider);
  });
};

